import React, { Component } from 'react'
import List from '../../components/ContactList'
import { getToken } from '../../lib'

class ContactList extends Component {
  componentDidMount () {
    const token = getToken()
    this.props.fetchContactList(token)
  }

  render () {
    return (
      <div style={{height: '78vh', overflow: 'auto'}}>
        <div style={{width: 868}} className="pt3">
          <List
            location={this.props.location.pathname}
            isFetchingList={this.props.isFetchingList}
            contacts={this.props.contacts}
            createContactList={this.props.createContactList}
            fetchContactList={this.props.fetchContactList}
          />
        </div>
      </div>
    )
  }
}

export default ContactList



// WEBPACK FOOTER //
// ./src/routes/Contacts/Contacts.js